import React, { useContext } from "react";
import CartContext from "../../store/cart-context";
import classes from "./MealItem.module.css";
import MealItemForm from "./MealItemForm";

const MealItem = (props) => {
  const cartCtx = useContext(CartContext);
  const price = `$${props.price.toFixed(2)}`;

  const addToCartHandler = (amount) => {
    cartCtx.addItem({
      id: props.id,
      name: props.name,
      amount: amount,
      price: props.price,
    });
  };

  return (
    <>
      <li className={classes.meal}>
        <div>
          <h3 className={classes}>{props.name}</h3>
          <p className={classes.description}>{props.description}</p>
          <div className={classes.price}>{price}</div>
        </div>
        <div>
          <MealItemForm addItem={addToCartHandler} id={props.id} />
        </div>
      </li>
    </>
  );
};

export default MealItem;
